import type {
	CommentCreateDto,
	CommentListResponseDto,
	CommentResponseDto,
	FetchResponseOfError,
	FetchResponseOfSuccess,
} from "Infrastructure/Api/Api";
import {
	SortOrder,
	sortByDate,
} from "Infrastructure/Utilities/Helpers/sortByDate";
import { BaseCard } from "Shared/Components/Cards/BaseCard";
import { CommentDetail } from "Shared/Components/Comments/Components/CommentDetail";
import { CommentForm } from "Shared/Components/Comments/Form/CommentForm";
import { Stack } from "@mui/material";
import type { UseMutationResult } from "@tanstack/react-query";
import type { FC } from "react";

type CommentsProps = {
	addComment: UseMutationResult<
		FetchResponseOfSuccess<CommentResponseDto, 200> | FetchResponseOfError,
		Error,
		CommentCreateDto,
		unknown
	>;
	updateCommentMutation: UseMutationResult<
		CommentResponseDto,
		Error,
		{ data: CommentCreateDto; commentId: number },
		unknown
	>;
	deleteCommentMutation: UseMutationResult<void, Error, number, unknown>;
	comments?: CommentListResponseDto[];
	title?: string;
};

export const Comments: FC<CommentsProps> = ({
	addComment,
	comments,
	title,
	updateCommentMutation,
	deleteCommentMutation,
}) => {
	const { mutate: createComment, isPending } = addComment;

	return (
		<Stack gap={2}>
			<BaseCard
				title={title}
				sxCardContent={{ padding: "8px 14px !important" }}
			>
				<CommentForm onSubmit={createComment} isPending={isPending} />
			</BaseCard>
			{sortByDate("dateCreated", comments, SortOrder.ASC).map((comment) => (
				<CommentDetail
					key={comment.id}
					comment={comment}
					updateCommentMutation={updateCommentMutation}
					deleteCommentMutation={deleteCommentMutation}
				/>
			))}
		</Stack>
	);
};
